<script setup>

import {TablerIconEnum} from "@/v2/enumerate/component/tabler";

/**
 * 傳入 - 參數
 */
const props = defineProps({
    name: { type: null, required: true, default: TablerIconEnum.HEADSET },
    size: { type: Number, required: false, default: 24 },
    strokeWidth: { type: Number, required: false, default: 1.5 }
  })

</script>

<template>
  <x-icon :stroke-width="props.strokeWidth"
          :size="props.size"
          v-if="props.name === TablerIconEnum.X" />
  <brand-apple-icon :stroke-width="props.strokeWidth"
                            :size="props.size"
                            v-else-if="props.name === TablerIconEnum.BRAND_APPLE" />
  <brand-android-icon :stroke-width="props.strokeWidth"
                      :size="props.size"
                      v-else-if="props.name === TablerIconEnum.BRAND_ANDROID" />
  <settings-automation-icon :stroke-width="props.strokeWidth"
                            :size="props.size"
                            v-else-if="props.name === TablerIconEnum.SETTINGS_AUTOMATION" />
  <broadcast-icon :stroke-width="props.strokeWidth"
                  :size="props.size"
                  v-else-if="props.name === TablerIconEnum.BROADCAST" />
  <letter-o-icon :stroke-width="props.strokeWidth"
                                :size="props.size"
                                v-else-if="props.name === TablerIconEnum.LETTER_O" />
  <letter-d-icon :stroke-width="props.strokeWidth"
                                :size="props.size"
                                v-else-if="props.name === TablerIconEnum.LETTER_D" />
  <letter-w-icon :stroke-width="props.strokeWidth"
                                :size="props.size"
                                v-else-if="props.name === TablerIconEnum.LETTER_W" />
  <letter-m-icon :stroke-width="props.strokeWidth"
                                :size="props.size"
                                v-else-if="props.name === TablerIconEnum.LETTER_M" />
  <letter-y-icon :stroke-width="props.strokeWidth"
                                :size="props.size"
                                v-else-if="props.name === TablerIconEnum.LETTER_Y" />
  <antenna-bars-5-icon :stroke-width="props.strokeWidth"
                       :size="props.size"
                       v-else-if="props.name === TablerIconEnum.ANTENNA_BARS_5" />
  <copy-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.COPY" />
  <dots-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.DOTS" />
  <viewfinder-icon :stroke-width="props.strokeWidth"
                   :size="props.size"
                   v-else-if="props.name === TablerIconEnum.VIEW_FINDER" />
  <bell-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.BELL" />
  <repeat-icon :stroke-width="props.strokeWidth"
               :size="props.size"
               v-else-if="props.name === TablerIconEnum.REPEAT" />
  <shield-lock-icon :stroke-width="props.strokeWidth"
                    :size="props.size"
                    v-else-if="props.name === TablerIconEnum.SHIELD_LOCK" />
  <shield-check-icon :stroke-width="props.strokeWidth"
                     :size="props.size"
                     v-else-if="props.name === TablerIconEnum.SHIELD_CHECK" />
  <history-icon :stroke-width="props.strokeWidth"
                :size="props.size"
                v-else-if="props.name === TablerIconEnum.HISTORY" />
  <file-orientation-icon :stroke-width="props.strokeWidth"
                         :size="props.size"
                         v-else-if="props.name === TablerIconEnum.FILE_ORIENTATION" />
  <book-upload-icon :stroke-width="props.strokeWidth"
                    :size="props.size"
                    v-else-if="props.name === TablerIconEnum.BOOK_UPLOAD" />
  <link-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.LINK" />
  <unlink-icon :stroke-width="props.strokeWidth"
               :size="props.size"
               v-else-if="props.name === TablerIconEnum.UNLINK" />
  <trash-icon :stroke-width="props.strokeWidth"
              :size="props.size"
              v-else-if="props.name === TablerIconEnum.TRASH" />
  <clock-icon :stroke-width="props.strokeWidth"
              :size="props.size"
              v-else-if="props.name === TablerIconEnum.CLOCK" />
  <hourglass-empty-icon :stroke-width="props.strokeWidth"
                        :size="props.size"
                        v-else-if="props.name === TablerIconEnum.HOURGLASS_EMPTY" />
  <flag-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.FLAG" />
  <arrow-back-up-icon :stroke-width="props.strokeWidth"
                      :size="props.size"
                      v-else-if="props.name === TablerIconEnum.ARROW_BACK_UP" />
  <ban-icon :stroke-width="props.strokeWidth"
            :size="props.size"
            v-else-if="props.name === TablerIconEnum.BAN" />
  <flame-icon :stroke-width="props.strokeWidth"
              :size="props.size"
              v-else-if="props.name === TablerIconEnum.FLAME" />
  <sun-icon :stroke-width="props.strokeWidth"
            :size="props.size"
            v-else-if="props.name === TablerIconEnum.SUN" />
  <moon-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.MOON" />
  <plus-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.PLUS" />
  <home-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.HOME" />
  <star-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.STAR" />
  <building-icon :stroke-width="props.strokeWidth"
                 :size="props.size"
                 v-else-if="props.name === TablerIconEnum.BUILDING" />
  <id-badge2-icon :stroke-width="props.strokeWidth"
                  :size="props.size"
                  v-else-if="props.name === TablerIconEnum.ID_BADGE2" />
  <prompt-icon :stroke-width="props.strokeWidth"
               :size="props.size"
               v-else-if="props.name === TablerIconEnum.PROMPT" />
  <user-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.USER" />
  <user-check-icon :stroke-width="props.strokeWidth"
                   :size="props.size"
                   v-else-if="props.name === TablerIconEnum.USER_CHECK" />
  <users-group-icon :stroke-width="props.strokeWidth"
                    :size="props.size"
                    v-else-if="props.name === TablerIconEnum.USERS_GROUP" />
  <lock-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.LOCK" />
  <code-icon :stroke-width="props.strokeWidth"
             :size="props.size"
             v-else-if="props.name === TablerIconEnum.CODE" />
  <tag-icon :stroke-width="props.strokeWidth"
            :size="props.size"
            v-else-if="props.name === TablerIconEnum.TAG" />
  <check-icon :stroke-width="props.strokeWidth"
              :size="props.size"
              v-else-if="props.name === TablerIconEnum.CHECK" />
  <minus-icon :stroke-width="props.strokeWidth"
              :size="props.size"
              v-else-if="props.name === TablerIconEnum.MINUS" />
  <brand-youtube-icon :stroke-width="props.strokeWidth"
                      :size="props.size"
                      v-else-if="props.name === TablerIconEnum.BRAND_YOUTUBE" />
  <photo-icon :stroke-width="props.strokeWidth"
              :size="props.size"
              v-else-if="props.name === TablerIconEnum.PHOTO" />
  <paperclip-icon :stroke-width="props.strokeWidth"
                  :size="props.size"
                  v-else-if="props.name === TablerIconEnum.PAPERCLIP" />
  <pencil-icon :stroke-width="props.strokeWidth"
               :size="props.size"
               v-else-if="props.name === TablerIconEnum.PENCIL" />
  <pencil-off-icon :stroke-width="props.strokeWidth"
                   :size="props.size"
                   v-else-if="props.name === TablerIconEnum.PENCIL_OFF" />
  <gauge-icon :stroke-width="props.strokeWidth"
              :size="props.size"
              v-else-if="props.name === TablerIconEnum.GAUGE" />
  <message-circle-icon :stroke-width="props.strokeWidth"
                       :size="props.size"
                       v-else-if="props.name === TablerIconEnum.MESSAGE_CIRCLE" />
  <search-icon :stroke-width="props.strokeWidth"
               :size="props.size"
               v-else-if="props.name === TablerIconEnum.SEARCH" />
  <headset-icon :stroke-width="props.strokeWidth"
                :size="props.size"
                v-else-if="props.name === TablerIconEnum.HEADSET" />
  <map-pin-icon :stroke-width="props.strokeWidth"
                :size="props.size"
                v-else-if="props.name === TablerIconEnum.MAP_PIN" />
  <hand-stop-icon :stroke-width="props.strokeWidth"
                  :size="props.size"
                  v-else-if="props.name === TablerIconEnum.HAND_STOP" />
  <loader2-icon :stroke-width="props.strokeWidth"
                :size="props.size"
                v-else-if="props.name === TablerIconEnum.LOADER_2" />
  <microphone-icon :stroke-width="props.strokeWidth"
                   :size="props.size"
                   v-else-if="props.name === TablerIconEnum.MICROPHONE" />
  <chevron-right-icon :stroke-width="props.strokeWidth"
                      :size="props.size"
                      v-else-if="props.name === TablerIconEnum.CHEVRON_RIGHT" />
  <caret-up-icon :stroke-width="props.strokeWidth"
                 :size="props.size"
                 v-else-if="props.name === TablerIconEnum.CARET_UP" />
  <caret-down-icon :stroke-width="props.strokeWidth"
                   :size="props.size"
                   v-else-if="props.name === TablerIconEnum.CARET_DOWN" />
  <zoom-in-icon :stroke-width="props.strokeWidth"
                :size="props.size"
                v-else-if="props.name === TablerIconEnum.ZOOM_IN" />
  <zoom-out-icon :stroke-width="props.strokeWidth"
                 :size="props.size"
                 v-else-if="props.name === TablerIconEnum.ZOOM_OUT" />
  <zoom-exclamation-icon :stroke-width="props.strokeWidth"
                         :size="props.size"
                         v-else-if="props.name === TablerIconEnum.ZOOM_EXCLAMATION" />
  <arrows-maximize-icon :stroke-width="props.strokeWidth"
                        :size="props.size"
                        v-else-if="props.name === TablerIconEnum.ARROWS_MAXIMIZE" />
  <download-icon :stroke-width="props.strokeWidth"
                 :size="props.size"
                 v-else-if="props.name === TablerIconEnum.DOWNLOAD" />
  <rotate-clockwise-2-icon :stroke-width="props.strokeWidth"
                           :size="props.size"
                           v-else-if="props.name === TablerIconEnum.ROTATE_CLOCKWISE_2" />
  <arrow-left-icon :stroke-width="props.strokeWidth"
                   :size="props.size"
                   v-else-if="props.name === TablerIconEnum.ARROW_LEFT" />
  <arrow-right-icon :stroke-width="props.strokeWidth"
                    :size="props.size"
                    v-else-if="props.name === TablerIconEnum.ARROW_RIGHT" />
  <arrow-up-icon :stroke-width="props.strokeWidth"
                 :size="props.size"
                 v-else-if="props.name === TablerIconEnum.ARROW_TOP" />
  <arrow-down-icon :stroke-width="props.strokeWidth"
                 :size="props.size"
                 v-else-if="props.name === TablerIconEnum.ARROW_DOWN" />
  <arrow-bar-to-up-icon :stroke-width="props.strokeWidth"
                        :size="props.size"
                        v-else-if="props.name === TablerIconEnum.ARROW_BAR_TO_UP" />
  <arrow-bar-left-icon :stroke-width="props.strokeWidth"
                       :size="props.size"
                       v-else-if="props.name === TablerIconEnum.ARROW_BAR_LEFT" />
  <arrow-bar-right-icon :stroke-width="props.strokeWidth"
                        :size="props.size"
                        v-else-if="props.name === TablerIconEnum.ARROW_BAR_RIGHT" />
  <arrow-narrow-down-icon :stroke-width="props.strokeWidth"
                          :size="props.size"
                          v-else-if="props.name === TablerIconEnum.ARROW_NARROW_DOWN" />
  <exclamation-mark-icon :stroke-width="props.strokeWidth"
                         :size="props.size"
                         v-else-if="props.name === TablerIconEnum.EXCLAMATION_MARK" />
  <baseline-density-medium-icon :stroke-width="props.strokeWidth"
                                :size="props.size"
                                v-else-if="props.name === TablerIconEnum.BASELINE_DENSITY_MEDIUM" />
  <chart-line-icon :stroke-width="props.strokeWidth"
                   :size="props.size"
                   v-else-if="props.name === TablerIconEnum.CHART_LINE" />
  <timeline-icon :stroke-width="props.strokeWidth"
                 :size="props.size"
                 v-else-if="props.name === TablerIconEnum.TIMELINE" />
  <square-check-icon :stroke-width="props.strokeWidth"
                     :size="props.size"
                     v-else-if="props.name === TablerIconEnum.SQUARE_CHECK" />
  <player-play-filled-icon :stroke-width="props.strokeWidth"
                           :size="props.size"
                           v-else-if="props.name === TablerIconEnum.PLAYER_PLAY_FILLED" />
  <adjustments-horizontal-icon :stroke-width="props.strokeWidth"
                               :size="props.size"
                               v-else-if="props.name === TablerIconEnum.ADJUSTMENTS_HORIZONTAL" />
  <question-mark-icon :stroke-width="props.strokeWidth"
                      :size="props.size"
                      v-else-if="props.name === TablerIconEnum.QUESTION_MARK" />
</template>